import React, {useEffect, useState} from 'react';
import {useNavigate, useSearchParams} from "react-router-dom";
import {Alert, Button, Form} from 'react-bootstrap';

import AuthService from "../../services/auth.service";
import {withRouter} from '../../common/with-router';

import validator from 'validator'
import pfLogo from '../../img/social-logo.png';
import '../../Auth.css';


const ResetPassword = () => {
    // for validating token on page load
    const [searchParams, setSearchParams] = useSearchParams();  // eslint-disable-line no-unused-vars
    const [email, setEmail] = useState('');
    const [token, setToken] = useState('');
    const [validToken, setValidToken] = useState(false);

    // for updating password
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [errors, setErrors] = useState({});

    const navigate = useNavigate();

    const validateForm = () => {
        const newErrors = {};
        if (!validator.isStrongPassword(password, {
            minLength: 8,
            minLowercase: 1,
            minUppercase: 1,
            minNumbers: 1,
            minSymbols: 1
        })) {
            newErrors.password = 'Password must be at least 8 characters long, ' +
                'with at least: 1 lower case letter, 1 upper case letter, 1 number, 1 symbol';
        }
        if (password !== confirmPassword) {
            newErrors.confirmPassword = "Passwords don't match";
        }
        return newErrors;
    };

    const validateToken = () => {
        setEmail(searchParams.get("email"));
        setToken(searchParams.get("token"));
        if (email !== '' && token !== '') {
            console.log("inside validate, email=" + email + ", token=" + token);
            AuthService.validatePassToken(email, token).then(
                () => {
                    setValidToken(true);
                },
                error => {
                    const newErrors = {};
                    newErrors.validation = error.response.data.error
                    setErrors(newErrors);
                }
            )
        }
    }

    useEffect(() => {
        validateToken();
    }, [email, token]);  // eslint-disable-line react-hooks/exhaustive-deps

    const handleSubmit = (event) => {
        event.preventDefault();
        const formErrors = validateForm();
        if (Object.keys(formErrors).length > 0) {
            setErrors(formErrors);
        } else {
            setErrors({});
            AuthService.updatePass(email, password).then(
                () => {
                    navigate("/login?resetPass=true");
                    window.location.reload();
                },
                error => {
                    const newErrors = {};
                    newErrors.updatePass = error.response.data.error
                    setErrors(newErrors);
                }
            )
        }
    };

    return (
        <div className="auth-wrapper">
            <div className="auth-form-container">
                <h2 className="auth-title">
                    <img src={pfLogo}
                         alt="Winchester Porchfest"
                         title="Winchester Porchfest"
                         height="80px"
                         className="profile-img-card"/>
                </h2>

                {!validToken &&
                    <div>
                        <br/>
                        <Alert variant="danger">{errors.validation}</Alert>
                    </div>
                }

                {validToken &&
                    <Form.Group>
                        <Form onSubmit={handleSubmit} className="auth-form">
                            <Form.Group className="mb-3">
                                <Form.Label>New Password:</Form.Label>
                                <Form.Control
                                    type="password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    isInvalid={!!errors.password}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {errors.password}
                                </Form.Control.Feedback>
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label>Confirm password:</Form.Label>
                                <Form.Control
                                    type="password"
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    isInvalid={!!errors.confirmPassword}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {errors.confirmPassword}
                                </Form.Control.Feedback>
                            </Form.Group>

                            <Button variant="primary" type="submit" className="auth-button">
                                Submit
                            </Button>

                            {errors && errors.updatePass &&
                                <div>
                                    <br/>
                                    <Alert variant="danger">{errors.updatePass}</Alert>
                                </div>
                            }
                        </Form>
                    </Form.Group>
                }
            </div>
        </div>
    );
}

export default withRouter(ResetPassword);